import { useCallback } from 'react';
import { useSettingsStore } from '@/stores/settingsStore';

type HapticNotificationType = 'error' | 'success' | 'warning';
type HapticImpactStyle = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';

interface TelegramHapticFeedback {
  impactOccurred?: (style: HapticImpactStyle) => void;
  notificationOccurred?: (type: HapticNotificationType) => void;
  selectionChanged?: () => void;
}

interface TelegramWebApp {
  HapticFeedback?: TelegramHapticFeedback;
}

interface TelegramWindow extends Window {
  Telegram?: {
    WebApp?: TelegramWebApp;
  };
}

function getHapticFeedback(): TelegramHapticFeedback | undefined {
  return (window as TelegramWindow).Telegram?.WebApp?.HapticFeedback;
}

export function useHapticFeedback() {
  const hapticEnabled = useSettingsStore(state => state.hapticEnabled);

  const notify = useCallback((type: HapticNotificationType) => {
    if (!hapticEnabled) return;
    getHapticFeedback()?.notificationOccurred?.(type);
  }, [hapticEnabled]);

  const impact = useCallback((style: HapticImpactStyle = 'light') => {
    if (!hapticEnabled) return;
    getHapticFeedback()?.impactOccurred?.(style);
  }, [hapticEnabled]);

  const selection = useCallback(() => {
    if (!hapticEnabled) return;
    getHapticFeedback()?.selectionChanged?.();
  }, [hapticEnabled]);

  return { notify, impact, selection };
}
